import React, { useState, useEffect } from 'react';
import './NewYearAlert.css';

const NewYearAlert = () => {
  const [showModal, setShowModal] = useState(false);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if it's January (new year period)
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth(); // 0-11, where 0 is January
    const currentYear = currentDate.getFullYear();
    
    // Show alert in January (month 0)
    if (currentMonth === 0) {
      // Check if user has dismissed the banner for this year
      const dismissedBannerYear = localStorage.getItem('newYearBannerDismissed');
      
      // Check if user has dismissed the modal for this year
      const dismissedModalYear = localStorage.getItem('newYearAlertDismissed');
      
      // Show banner if not dismissed for this year
      if (dismissedBannerYear !== String(currentYear)) {
        setShowBanner(true);
      }
      
      // Show modal if not dismissed for this year
      if (dismissedModalYear !== String(currentYear)) {
        const timer = setTimeout(() => {
          setShowModal(true);
        }, 2000);
        
        return () => clearTimeout(timer);
      }
    }
  }, []);

  const handleCloseModal = () => {
    const currentYear = new Date().getFullYear();
    localStorage.setItem('newYearAlertDismissed', String(currentYear));
    setShowModal(false);
  };

  const handleCloseBanner = () => {
    const currentYear = new Date().getFullYear();
    localStorage.setItem('newYearBannerDismissed', String(currentYear));
    setShowBanner(false);
  };

  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Floating Banner Alert */}
      {showBanner && (
        <div className="new-year-banner">
          <div className="new-year-banner-content">
            <span className="new-year-banner-icon">🎉</span>
            <span className="new-year-banner-text">
              Happy New Year {currentYear}! Wishing you a prosperous year filled with successful investments!
            </span>
            <button className="new-year-banner-close" onClick={handleCloseBanner}>×</button>
          </div>
        </div>
      )}

      {/* Modal Popup */}
      {showModal && (
        <div className="new-year-alert-overlay">
          <div className="new-year-alert">
            <button className="new-year-close-btn" onClick={handleCloseModal}>×</button>
            <div className="new-year-content">
              <div className="new-year-icon">🎉</div>
              <h2 className="new-year-title">Happy New Year {currentYear}!</h2>
              <p className="new-year-message">
                Wishing you a prosperous year filled with successful investments and financial growth!
              </p>
              <p className="new-year-submessage">
                Start the new year with professional investment guidance from Trillion Stock Research.
              </p>
              <button className="new-year-cta-btn" onClick={handleCloseModal}>
                Let's Make It Great!
              </button>
            </div>
            <div className="new-year-confetti">
              <span>🎊</span>
              <span>✨</span>
              <span>🎈</span>
              <span>⭐</span>
              <span>🎉</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewYearAlert;

